// Shown for any URL the site doesn't know (App.js catch-all route).
import React, { useEffect } from 'react';
import { PiArrowRight, PiHouse } from 'react-icons/pi';
import { Button } from '../ui';
import InfoPage, { PageHero } from './InfoPage';

export default function NotFoundPage() {
  // Vercel serves the app for every path, so tell search engines this one isn't a real page.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <InfoPage
      title="Page not found"
      description="The page you were looking for doesn’t exist."
      band={false}
      hero={(
        <PageHero
          eyebrow="Error 404"
          title={<>This page took a <em>wrong turn</em></>}
          lead="The link may be old or mistyped. Let’s get you back on the road."
        >
          <div className="pg-actions">
            <Button to="/" icon={PiHouse}>Go to the home page</Button>
            <Button to="/book" variant="secondary" iconAfter={PiArrowRight}>Book a ride</Button>
          </div>
        </PageHero>
      )}
    />
  );
}
